/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import {
    asyncDefaults,
    makeAsyncReducer,
    mergeReducers,
} from 'ui-permit/shared-components/utils/async';
import { PREFIX } from '../constants';
import * as ACTIONS from '../constants/actions';

const INITIAL_STATE = [];

const getLotteries = makeAsyncReducer(ACTIONS.FETCH_LOTTERIES);
export const lotteries = mergeReducers(
    asyncDefaults(INITIAL_STATE),
    PREFIX,
    getLotteries
);

const fetchLottery = makeAsyncReducer(ACTIONS.FETCH_LOTTERY);
export const lottery = mergeReducers(asyncDefaults({}), PREFIX, fetchLottery);

const fetchLotteryIssuance = makeAsyncReducer(ACTIONS.FETCH_LOTTERY_ISSUANCE);
export const lotteryIssuance = mergeReducers(
    asyncDefaults({}),
    PREFIX,
    fetchLotteryIssuance
);

const cancelLotteryIssuance = makeAsyncReducer(ACTIONS.CANCEL_LOTTERY_ISSUANCE);
export const lotteryIssuanceCancel = mergeReducers(
    asyncDefaults({}),
    PREFIX,
    cancelLotteryIssuance
);

const acceptLotteryIssuance = makeAsyncReducer(ACTIONS.ACCEPT_LOTTERY_ISSUANCE);
export const lotteryIssuanceAccept = mergeReducers(
    asyncDefaults({}),
    PREFIX,
    acceptLotteryIssuance
);

export const selectors = {
    getLotteries: (state) => {
        if (state.huntingpermit.lotteries) {
            return state.huntingpermit.lotteries.data;
        }
        return [];
    },
    getLottery: (state) => {
        if (state.huntingpermit.lottery) {
            return state.huntingpermit.lottery.data;
        }
        return {};
    },
    getLotteriesError: (state) => {
        return state.huntingpermit.lotteries?.error ?? '';
    },
    getLotteryError: (state) => {
        if (state.huntingpermit.lottery && state.huntingpermit.lottery.error) {
            return state.huntingpermit.lottery.error;
        }
        return {};
    },
    getLotteryLoading: (state) => state.huntingpermit.lottery.loading,
    getLotteryLoaded: (state) => state.huntingpermit.lottery.loaded,
    getLotteryIssuance: (state) => {
        if (state.huntingpermit.lotteryIssuance) {
            return state.huntingpermit.lotteryIssuance.data;
        }
        return {};
    },
    getLotteryIssuanceError: (state) => {
        if (
            state.huntingpermit.lotteryIssuance &&
            state.huntingpermit.lotteryIssuance.error
        ) {
            return state.huntingpermit.lotteryIssuance.error;
        }
        return {};
    },
    getLotteryIssuanceLoading: (state) => state.huntingpermit.lotteryIssuance.loading,
    getLotteryIssuanceLoaded: (state) => state.huntingpermit.lotteryIssuance.loaded,
    getLotteryIssuanceCancelError: (state) =>
        state?.huntingpermit?.lotteryIssuanceCancel?.error,
    getLotteryIssuanceCancelLoading: (state) =>
        state?.huntingpermit?.lotteryIssuanceCancel?.loading,
    getLotteryIssuanceAcceptError: (state) =>
        state?.huntingpermit?.lotteryIssuanceAccept?.error,
    getLotteryIssuanceAcceptLoading: (state) =>
        state?.huntingpermit?.lotteryIssuanceAccept?.loading,
};
